import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState<{ [key: string]: boolean }>({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [ctaIndex, setCtaIndex] = useState(0);

  const heroImages = [
    'https://static.readdy.ai/image/b1989ece91adf9f4c331600c20412c5d/981fe015c996cda23ac76a936afe9750.jpeg',
  ];

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      const sections = document.querySelectorAll('[data-animate]');
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const id = section.getAttribute('data-animate') || '';
        if (rect.top < window.innerHeight * 0.8) {
          setIsVisible((prev) => ({ ...prev, [id]: true }));
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollTable = (direction: 'left' | 'right') => {
    const el = document.getElementById('comparison-scroll');
    if (el) {
      el.scrollBy({ left: direction === 'right' ? 200 : -200, behavior: 'smooth' });
    }
  };

  const strengths = [
    {
      number: 1,
      title: '일본에서 홈페이지 제작 40건 이상, 2차 외주까지 포함하면 60건 이상',
      description:
        '풍부한 실전 경험을 바탕으로 일본 시장에 최적화된 웹사이트를 제작합니다.',
    },
    {
      number: 2,
      title: '일본 변호사가 진행하는 법무 체크 무료 제공',
      description: '일본의 까다로운 법규제를 완벽히 준수하여 안전한 비즈니스 진출을 도와 드립니다.',
    },
    {
      number: 3,
      title: '한국어 담당자는 전원 TOPIK（한국어 능력 시험） 5급 이상 일본인으로, 의사소통 문제 없음',
      description: '언어 장벽 없이 원활한 커뮤니케이션으로 프로젝트를 진행합니다.',
    },
    {
      number: 4,
      title: '번역으로 끝나지 않고 일본인에게 통하는 문장 제작',
      description: '단순 번역이 아닌 일본인의 감성과 문화를 반영한 네이티브 수준의 콘텐츠를 제공합니다.',
    },
    {
      number: 5,
      title: '실제로 다수의 한국 병원 기업의 일본 마케팅 진행 중',
      description: '의료, 뷰티 등 다양한 분야에서 검증된 마케팅 노하우를 보유하고 있습니다.',
    },
    {
      number: 6,
      title: '최소 1개월, 최대 2개월 반의 빠른 납품',
      description: '신속한 시장 진출을 위한 효율적인 프로젝트 관리로 긴급 의뢰에도 대응 가능합니다!',
    },
    {
      number: 7,
      title: '도메인 취득부터 디자인, 일본 서버 구축 및 유지보수까지 일괄 대응',
      description: '.jp 등, 도메인 취득부터 서버 관리까지 모든 과정을 원스톱으로 처리합니다.',
    },
    {
      number: 8,
      title: '랜딩페이지 500만 원 이내 확정 보장',
      description: '명확한 가격으로 추가 비용 걱정 없이 프로젝트를 진행할 수 있습니다.',
    },
    {
      number: 9,
      title: '홈페이지 2,000만 원 이내 확정 보장',
      description: '투명한 가격 설정으로 추가 비용 걱정 없이 완전한 현지화 대책을 실시한 홈페이지를 제작합니다.',
    },
    {
      number: 10,
      title: '팔로워 3만~5만 규모 인플루언서 1명 무료 제공',
      description: '웹사이트 제작과 함께 효과적인 SNS 마케팅으로 빠른 시장 진입을 지원합니다.',
    },
  ];

  const processSteps = [
    {
      number: 1,
      icon: 'ri-focus-3-line',
      title: '전략 미팅',
      description:
        '귀사의 강점과 일본 내 타겟을 심층적으로 이해하고, 성공을 위한 최적의 경로를 수립합니다.',
    },
    {
      number: 2,
      icon: 'ri-shake-hands-line',
      title: '계약',
      description: '합의된 전략을 바탕으로 공식적인 파트너십을 체결합니다.',
    },
    {
      number: 3,
      icon: 'ri-search-eye-line',
      title: '시장 분석 및 경쟁사 리서치',
      description: '일본 내 경쟁 업체들의 동향을 철저히 조사하여 차별화된 포지셔닝을 확정합니다.',
    },
    {
      number: 4,
      icon: 'ri-layout-grid-line',
      title: '와이어프레임 제작',
      description: '일본인의 구매 행동에 최적화된 정보 배치와 설계도를 구축합니다.',
    },
    {
      number: 5,
      icon: 'ri-quill-pen-line',
      title: '일본인 네이티브의 전략적 라이팅',
      description:
        '직역을 배제하고 타겟의 심리에 자연스럽게 소구하는 일본어 콘텐츠를 제작합니다.',
    },
    {
      number: 6,
      icon: 'ri-shield-check-line',
      title: '변호사 1차 법무 체크',
      description:
        '제작 초기 단계에서 일본 의료광고 가이드라인 및 약사법 준수 여부를 확인합니다.',
    },
    {
      number: 7,
      icon: 'ri-palette-line',
      title: 'UX/UI 디자인 제작',
      description:
        '일본인이 신뢰를 느낄 수 있는 청결하고 전문적인 비주얼 디자인을 완성합니다.',
    },
    {
      number: 8,
      icon: 'ri-code-s-slash-line',
      title: '코딩 및 일본 리전 서버 구축',
      description:
        '빠른 접속 속도와 SEO(검색 최적화)에 강한 기술적 기반을 일본 국내에 구축합니다.',
    },
    {
      number: 9,
      icon: 'ri-file-check-line',
      title: '변호사 2차 법무 체크',
      description:
        '디자인과 문구가 결합된 상태에서 법적 리스크를 다시 한번 면밀히 체크합니다.',
    },
    {
      number: 10,
      icon: 'ri-lock-line',
      title: '최종 검수',
      description: '공개 직전 최종 확인을 거쳐 법적 안전성과 마케팅 효과를 확정합니다.',
    },
    {
      number: 11,
      icon: 'ri-megaphone-line',
      title: '인플루언서 PR 실행 (선택 사항)',
      description:
        '필요에 따라 적합한 타겟군을 보유한 인플루언서를 매칭하여 초기 인지도를 확보합니다.',
    },
    {
      number: 12,
      icon: 'ri-rocket-line',
      title: '유지보수 및 광고 운용 시작',
      description:
        '공개 이후 성과를 극대화하기 위한 전문적인 운용 지원을 시작합니다.',
    },
  ];

  const faqs = [
    {
      question: '제작 지시나 수정 요청을 한국어로 해도 정확히 전달되나요?',
      answer:
        '네, 당연히 가능합니다. 저희 담당자는 전원 TOPIK(한국어능력시험) 5급 이상을 보유한 일본人입니다. TOPIK 5급은 전문적인 비즈니스 영역에서도 유창하게 한국어를 구사할 수 있는 수준으로 정의되며, 한국 기업 취업에도 무리가 없는 실력입니다. 의사소통의 장벽 없이 실시간으로 원활한 대응이 가능합니다.',
    },
    {
      question: '도메인은 선택할 수 있나요?',
      answer:
        "네, 원하시는 도메인으로 취득이 가능합니다.\n참고로 일본의 의료기관들이 주로 사용하는 '.jp' 도메인도 취득하실 수 있습니다.",
    },
    {
      question: '광고 운영이나 사이트 제작 중 하나만 의뢰할 수도 있나요?',
      answer: '네, 가능합니다. 귀사의 현재 상황과 예산에 맞춰 가장 효율적인 플랜을 제안해 드립니다.',
    },
    {
      question: '대면 미팅이 가능한가요?',
      answer: '네, 가능합니다. 대표가 매달 한국을 방문하고 있으므로 서울 시내 등에서 직접 미팅을 진행할 수 있습니다.',
    },
    {
      question: '결제는 어떻게 진행되나요?',
      answer: '저희는 착수금과 잔금으로 나누어 결제하는 시스템을 통해 클라이언트의 리스크를 최소화하고 있습니다.',
    },
    {
      question: '해외 송금이 처음인데 도움을 받을 수 있나요?',
      answer: '송금 절차부터 서류 준비까지 담당자가 상세히 안내해 드리므로 안심하셔도 됩니다.',
    },
    {
      question: '해외 업체(일본 기업)라 100% 신뢰하기가 어렵습니다.',
      answer:
        "인간관계에서 100%의 신뢰란 존재하지 않습니다.\n그 신뢰도가 70%인지 80%인지는 알 수 없지만, 저희에게 가능한 한의 신뢰를 보내주신다면 그 믿음을 반드시 결과로 보답하겠다고 약속드립니다.\n불안하시다면, 먼저 미팅을 통해 판단해 주셔도 좋습니다.\n비즈니스의 본질은 '리스크의 끝에 리턴이 있다'는 점입니다.\n익숙한 선택(자국의 업체)의 연장선에서는 미지의 시장에서의 큰 성공을 기대하기 어렵습니다.\n먼저 대표와 직접 이야기를 나누시고, 그 '전략'과 '진정성'을 직접 확인해 보시기 바랍니다.",
    },
    {
      question: '제작된 사이트의 소유권은 누구에게 있나요?',
      answer: '납품 완료 후 모든 소유권은 귀사에 귀속됩니다.',
    },
    {
      question: '유지보수는 어디까지 대응해 주나요?',
      answer: '플랜에 따라 범위가 다르므로 상세 내용은 문의해 주시기 바랍니다.',
    },
    {
      question: '무료 제공 인플루언서의 선정 기준은 무엇인가요?',
      answer:
        "선정 기준을 한마디로 말씀드리자면, 귀사의 타깃에 가장 적합한 인플루언서입니다.\n미팅을 통해 방향성을 확인한 후 선정해 드리고 있습니다.",
    },
    {
      question: '구글 검색 순위 상단을 보장하나요?',
      answer:
        'SEO에 있어 상위 노출을 확약하는 것은 불가능합니다만,\n일본의 최신 알고리즘에 기반한 내부 최적화 작업을 진행하여,\n상위에 노출되기 쉬운 상태로 구축·납품해 드립니다.\n또한 본격적인 SEO 운영을 전제로 한 블로그 콘텐츠 업데이트 등도\n플랜별로 제공하고 있으므로, 해당 부분 역시 상담해 주시면\n예산에 맞춰 유연하게 대응해 드리겠습니다.',
    },
    {
      question: '한국 변호사에게 검토를 받아도 충분하지 않나요?',
      answer:
        '법 조문을 읽을 수 있는 것과 일본 현지에서의 실제 운용 실무를 숙지하고 있는 것은 전혀 다른 문제입니다.\n대표인 저 역시 한국 변호사와 여러 차례 협의를 진행해 왔지만, 조문을 그대로 적용하는 것만으로는 일본 당국의 실제 운용 방식이나 전환율을 유지하면서 리스크를 회피하는 세밀한 표현까지 대응하기는 어렵습니다.\n현지의 실무 감각을 갖춘 전문가를 통해 진행하는 것이 가장 확실한 방법입니다.',
    },
    {
      question: 'AI 번역으로 제작하면 문제가 될까요?',
      answer:
        '의미가 전달되는 것과 일본인의 감정을 움직여 신뢰를 얻는 것은 전혀 다른 문제입니다. 고액의 비용이 수반되는 미용 의료 분야나, 단 한 순간에 행동을 유도해야 하는 랜딩페이지에서는 아주 미세한 표현의 어색함조차 \'신뢰할 수 없는 해외 업체\'라는 판단으로 이어져 이탈의 원인이 될 수 있습니다. AI는 정보를 전달할 수는 있지만, 시장을 공략하기 위한 전략적 라이팅은 불가능합니다. 사람의 마음을 움직이는 현지 감각의 라이팅은, 현지 업체인 저희에게 맡겨 주시기 바랍니다.',
    },
  ];

  const navItems = [
    { label: '강점', id: 'strengths' },
    { label: '가격', id: 'pricing' },
    { label: '철학', id: 'market-analysis' },
    { label: '비교표', id: 'services' },
    { label: '법무', id: 'legal' },
    { label: '프로세스', id: 'process' },
    { label: 'FAQ', id: 'faq' },
    { label: '대표', id: 'ceo-message' },
  ];

  const ctaTexts = [
    '무료 상담 신청하기',
    '매월 5개사 한정 광고 운영 3개월 무료',
    '아직 문의 안 하셨나요?',
    '랜딩페이지까지 오셨는데요?',
    '문의는 무료임에도 불구하고요?',
    '일본 시장 승자의 상식은',
    '바로 K-NEXUS입니다',
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCtaIndex((prev) => (prev + 1) % ctaTexts.length);
    }, 2800);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-white text-[#1A1A2E]">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-lg shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-6 lg:px-10 h-14 lg:h-20 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2 lg:gap-4 flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/b1989ece91adf9f4c331600c20412c5d/d4a602daafc972804a8f79cf255edce9.png"
              alt="K-NEXUS"
              className="h-8 lg:h-12 w-auto object-contain"
            />
            <div className="flex flex-col leading-tight">
              <span
                className={`font-bold text-sm lg:text-xl tracking-wide transition-colors duration-300 ${
                  isScrolled ? 'text-[#1A1A2E]' : 'text-white'
                }`}
              >
                K-NEXUS
              </span>
              <span className="text-[#3B9AFF] font-semibold text-[9px] lg:text-xs tracking-wider">
                MARKETING
              </span>
            </div>
          </div>

          {/* PC nav — 768px以上のみ */}
          {!isMobile && (
            <div className="flex items-center gap-3 lg:gap-5">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`hover:text-[#3B9AFF] transition-colors duration-300 cursor-pointer whitespace-nowrap text-xs lg:text-sm font-medium ${
                    isScrolled ? 'text-[#1A1A2E]' : 'text-white'
                  }`}
                >
                  {item.label}
                </button>
              ))}
              <a
                href="/contact"
                className="bg-[#3B9AFF] text-white px-5 lg:px-7 py-2 lg:py-2.5 rounded-full text-xs lg:text-sm font-bold hover:bg-[#2B8AEF] hover:shadow-lg hover:shadow-[#3B9AFF]/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                상담 신청
              </a>
            </div>
          )}

          {/* モバイル右側: CTAボタン + ハンバーガー — 768未満のみ */}
          {isMobile && (
            <div className="flex items-center gap-2">
              <a
                href="/contact"
                className="bg-[#3B9AFF] text-white px-4 py-2 rounded-full text-xs font-bold hover:bg-[#2B8AEF] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                상담 신청
              </a>
              <button
                className="flex items-center justify-center w-9 h-9 cursor-pointer"
                onClick={() => setMobileMenuOpen((v) => !v)}
                aria-label="メニュ"
              >
                <i
                  className={`text-2xl ${isScrolled ? 'text-[#1A1A2E]' : 'text-white'} ${
                    mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
                  }`}
                ></i>
              </button>
            </div>
          )}
        </div>

        {/* モバイルドロワーメニュー */}
        {isMobile && (
          <div
            className={`transition-all duration-300 overflow-hidden ${
              mobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
            } bg-white shadow-lg`}
          >
            <div className="flex flex-col px-4 py-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-sm font-bold text-[#1A1A2E] hover:text-[#3B9AFF] py-3 px-2 border-b border-[#E0EDFF] last:border-b-0 cursor-pointer whitespace-nowrap transition-colors duration-200"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          {heroImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Hero background ${index + 1}`}
              className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000 ${
                currentSlide === index ? 'opacity-100' : 'opacity-0'
              }`}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/70 via-[#0A1628]/60 to-[#0A1628]/80"></div>
        </div>

        <div className="relative z-10 text-center px-5 md:px-10 lg:px-6 max-w-5xl mx-auto w-full">
          <h1 className="font-bold text-2xl md:text-4xl lg:text-6xl xl:text-7xl leading-[1.5] md:leading-[1.4] mb-10 md:mb-14 lg:mb-20 text-white">
            <span className="text-[#5BB5FF]">번역만 한</span> 어색하고
            <br />
            부자연스러운 웹사이트,
            <br />
            이제는 <span className="text-[#5BB5FF]">끝내지 않으시겠습니까?</span>
          </h1>
        </div>

        <div className="relative z-10 flex justify-center w-full mt-4">
          <button
            onClick={() => scrollToSection('strengths')}
            className="cursor-pointer bg-transparent border-none p-2 animate-bounce"
            aria-label="다음 섹션으로 이동"
          >
            <i className="ri-arrow-down-line text-3xl md:text-4xl lg:text-5xl text-[#3B9AFF]"></i>
          </button>
        </div>
      </section>

      {/* Strengths Section */}
      <section
        id="strengths"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-white relative"
        data-animate="strengths"
      >
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-10 md:mb-16 lg:mb-24">
            <p className="text-[#3B9AFF] text-xs lg:text-sm font-bold tracking-[3px] mb-3 md:mb-4 uppercase">
              WHY K-NEXUS
            </p>
            <h2 className="text-xl md:text-3xl lg:text-5xl font-bold text-[#1A1A2E]">
              일본 진출, 왜 K-NEXUS인가?
            </h2>
            <p className="text-sm md:text-base lg:text-lg text-[#555] mt-3 md:mt-5">
              저희의 대표적인 강점 10가지는 다음과 같습니다.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-x-8 lg:gap-x-12 gap-y-4 md:gap-y-6 lg:gap-y-8">
            {strengths.map((strength, index) => (
              <div
                key={strength.number}
                className={`bg-[#F7FAFF] border border-[#E0EDFF] rounded-xl p-5 md:p-7 lg:p-10 hover:border-[#3B9AFF] hover:shadow-lg hover:shadow-[#3B9AFF]/10 hover:-translate-y-1 transition-all duration-300 cursor-pointer ${
                  isVisible.strengths ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-center gap-3 md:gap-4 mb-3 md:mb-4 lg:mb-6">
                  <div className="w-9 h-9 md:w-11 md:h-11 lg:w-14 lg:h-14 rounded-full bg-[#3B9AFF] flex items-center justify-center flex-shrink-0 shadow-md shadow-[#3B9AFF]/20">
                    <span className="text-white text-sm md:text-base lg:text-xl font-bold">
                      {strength.number}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base lg:text-xl font-bold text-[#1A1A2E] leading-snug">
                    {strength.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm lg:text-base text-[#777] leading-relaxed mb-4 md:mb-5 lg:mb-6">
                  {strength.description}
                </p>
                <div className="w-12 md:w-14 lg:w-16 h-px bg-gradient-to-r from-[#3B9AFF] to-transparent"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section
        id="pricing"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-[#F7FAFF] relative"
        data-animate="pricing"
      >
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-10 md:mb-16 lg:mb-24">
            <h2 className="text-xl md:text-3xl lg:text-5xl font-bold mb-2 md:mb-3 lg:mb-4 text-[#1A1A2E]">
              명확한 가격, 숨은 비용 없음
            </h2>
            <p className="text-[#999] text-xs md:text-sm lg:text-base">
              ※ 모든 가격은 부가세 별도입니다
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
            {/* LP Plan */}
            <div
              className={`bg-white border-2 border-[#3B9AFF] rounded-2xl p-6 md:p-8 lg:p-14 shadow-xl shadow-[#3B9AFF]/10 transition-all duration-700 ${
                isVisible.pricing ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="bg-[#3B9AFF] text-white text-xs lg:text-sm font-bold px-4 md:px-5 py-1.5 md:py-2 rounded-full inline-block mb-5 md:mb-6 lg:mb-8">
                LANDING PAGE
              </div>
              <div className="text-center mb-8 md:mb-10 lg:mb-14">
                <p className="text-3xl md:text-4xl lg:text-6xl font-bold mb-2 md:mb-3 lg:mb-4 text-[#1A1A2E]">
                  500만 원 이내
                </p>
                <p className="text-[#3B9AFF] text-base md:text-lg lg:text-xl font-semibold">
                  확정 보장
                </p>
              </div>
              <div className="mb-6 md:mb-7 lg:mb-8">
                <h3 className="text-sm md:text-base lg:text-lg font-bold text-[#1A1A2E] mb-4 md:mb-5 lg:mb-6">
                  일본 시장 내 전환율 및 법무 준수에 특화된 1페이지 구성
                </h3>
                <ul className="space-y-4 md:space-y-5 lg:space-y-6">
                  {[
                    {
                      title:
                        '일본 의료광고 가이드라인 및 약사법 기반 무료 법무 체크',
                      desc: '변호사 협력을 통해 일본 진출 시 가장 큰 리스크인 광고 중단 및 행정 지도를 미연에 방지합니다.',
                    },
                    {
                      title: "일본인 특유의 구매 심리를 반영한 일본 전용 '롱폼(Long-form)' UX 설계",
                      desc: '사이트 접속 속도 최적화 및 일본 구글(Google JP) 검색 엔진 최적화(SEO)에 유리한 기술적 기반을 구축します.',
                    },
                    {
                      title: '일본 시장 내 경쟁사 리서치를 바탕으로 한 차별화 전략 반영',
                      desc: "'지역명+시술명' 등 핵심 키워드 검색 시 상단 노출을 노릴 수 있도록 고도화된 내부 SEO 구축을 완료합니다.",
                    },
                    {
                      title: '납품 후 일본어 텍스트 수정 및 운영을 지원하는 한국어 전담 창구',
                      desc: '캠페인 공지 추가 등 수정 사항 발생 시, 한국어 채팅 문의만으로 일본인 전담 담당자가 신속하고 정확하게 대응합니다.',
                    },
                    {
                      title: '향후 다지점 확장을 고려한 고확장성 CMS 구축 및 운영 가이드 제공',
                      desc: '지점 확대 시에도 일괄 관리가 가능한 시스템을 구축하며, 한국 본사 담당자를 위한 전용 운영 가이드를 완비합니다.',
                    },
                  ].map((item, i) => (
                    <li key={i}>
                      <div className="flex items-start gap-2 md:gap-3 mb-1 md:mb-2">
                        <div className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-base md:text-lg lg:text-xl text-[#3B9AFF]"></i>
                        </div>
                        <span className="text-xs md:text-sm lg:text-base text-[#1A1A2E] font-semibold">
                          {item.title}
                        </span>
                      </div>
                      <p className="text-xs lg:text-sm text-[#777] ml-6 md:ml-8">{item.desc}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="/contact"
                className="block w-full py-3 md:py-3.5 lg:py-4 border-2 border-[#3B9AFF] text-[#3B9AFF] rounded-lg text-sm lg:text-base font-bold hover:bg-[#3B9AFF] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
              >
                랜딩페이지 제작 상담하기
              </a>
            </div>
            {/* Website Plan */}
            <div
              className={`bg-white border-2 border-[#3B9AFF] rounded-2xl p-6 md:p-8 lg:p-14 shadow-xl shadow-[#3B9AFF]/10 transition-all duration-700 ${
                isVisible.pricing ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="bg-[#3B9AFF] text-white text-xs lg:text-sm font-bold px-4 md:px-5 py-1.5 md:py-2 rounded-full inline-block mb-5 md:mb-6 lg:mb-8">
                FULL WEBSITE
              </div>
              <div className="text-center mb-8 md:mb-10 lg:mb-14">
                <p className="text-3xl md:text-4xl lg:text-6xl font-bold mb-2 md:mb-3 lg:mb-4 text-[#1A1A2E]">
                  2,000만 원 이내
                </p>
                <p className="text-[#3B9AFF] text-base md:text-lg lg:text-xl font-semibold">
                  확정 보장
                </p>
              </div>
              <div className="mb-6 md:mb-7 lg:mb-8">
                <h3 className="text-sm md:text-base lg:text-lg font-bold text-[#1A1A2E] mb-4 md:mb-5 lg:mb-6">
                  일본 시장 내 장기적인 브랜드 구축 및 자산화를 목적으로 한 다기능 사이트
                </h3>
                <ul className="space-y-4 md:space-y-5 lg:space-y-6">
                  {[
                    {
                      title: '일본 현지 상위층을 타겟으로 한 하이엔드 브랜딩 디자인',
                      desc: '일본 국내 유수의 고급 클리닉과 비교해도 손색없는 신뢰와 품격이 느껴지는 프리미엄 시각 연출을 진행합니다.',
                    },
                    {
                      title: "일본 내 일본 현지 서버 구축 및 '.jp' 도메인 취득을 통한 물리적 신뢰 확보",
                      desc: '사이트 접속 속도 최적화 및 일본 구글(Google JP) 검색 엔진 최적화(SEO)에 유리한 기술적 기반을 구축합니다.',
                    },
                    {
                      title: '일본 시장 내 경쟁사 리서치를 바탕으로 한 차별화 전략 반영',
                      desc: '현지 경쟁 병원의 동향을 정밀 분석하여, 귀사의 독보적인 강점을 일본인이 이해하기 쉬운 구조로 사이트에 녹여냅니다.',
                    },
                    {
                      title: '일본 구글 검색(SEO) 및 구글 지도(MEO) 초기 최적화 세팅',
                      desc: "'지역명+시술명' 등 핵심 키워드 검색 시 상단 노출을 노릴 수 있도록 고도화된 내부 SEO 구축을 완료합니다.",
                    },
                    {
                      title: '납품 후 일본어 텍스트 수정 및 운영을 지원하는 한국어 전담 창구',
                      desc: '캠페인 공지 추가 등 수정 사항 발생 시, 한국어 채팅 문의만으로 일본인 전담 담당자가 신속하고 정확하게 대응합니다.',
                    },
                    {
                      title: '향후 다지점 확장을 고려한 고확장성 CMS 구축 및 운영 가이드 제공',
                      desc: '지점 확대 시에도 일괄 관리가 가능한 시스템을 구축하며, 한국 본사 담당자를 위한 전용 운영 가이드를 완비합니다.',
                    },
                  ].map((item, i) => (
                    <li key={i}>
                      <div className="flex items-start gap-2 md:gap-3 mb-1 md:mb-2">
                        <div className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-base md:text-lg lg:text-xl text-[#3B9AFF]"></i>
                        </div>
                        <span className="text-xs md:text-sm lg:text-base text-[#1A1A2E] font-semibold">
                          {item.title}
                        </span>
                      </div>
                      <p className="text-xs lg:text-sm text-[#777] ml-6 md:ml-8">{item.desc}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="/contact"
                className="block w-full py-3 md:py-3.5 lg:py-4 border-2 border-[#3B9AFF] text-[#3B9AFF] rounded-lg text-sm lg:text-base font-bold hover:bg-[#3B9AFF] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
              >
                홈페이지 제작 상담하기
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Market Analysis Section */}
      <section
        id="market-analysis"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-white"
        data-animate="market-analysis"
      >
        <div className="max-w-5xl mx-auto">
          <div className={`transition-all duration-700 ${isVisible['market-analysis'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="text-center mb-10 md:mb-14 lg:mb-20">
              <p className="text-[#3B9AFF] text-xs lg:text-sm font-bold tracking-[3px] mb-3 md:mb-4 uppercase">
                HOME GROUND ADVANTAGE
              </p>
              <h2 className="text-xl md:text-3xl lg:text-5xl font-bold text-[#1A1A2E] leading-tight mb-6 md:mb-8">
                자국 시장 마케팅에서<br />해외 업체에 패배하는 일은<br />결코 일어날 수 없습니다.
              </h2>
            </div>
            <div className="space-y-6 md:space-y-7 lg:space-y-8 text-sm md:text-base lg:text-lg leading-relaxed text-[#444]">
              <p>
                귀사가 한국 국내에서 전개하고 있는 마케팅 활동에서, 일본의 기업에게 패배하는 모습을 상상하실 수 있습니까? 아마 대답은{' '}
                <strong className="text-[#1A1A2E]">"아니요"</strong>일 것입니다. 현지의 문화와 언어의 미세한 뉘앙스, 그리고 생활 전반에 뿌리내린 '감각'을 가장 잘 아는 것은 결국 그 땅에서 살아가는 사람들입니다.
              </p>
              <p>
                이 당연한 사실은 일본 시장에서도 똑같이 적용됩니다. 한국 진출을 일본 현지를 모르는 한국 업체에 맡기는 것은,{' '}
                <strong className="text-[#FF6B6B]">문화적 감수성이라는 거대한 벽 앞에서 스스로 압도적인 불리함을 안고 진출하는 것과 다름없습니다.</strong>
              </p>
              <div className="bg-[#F7FAFF] border-l-4 border-[#3B9AFF] p-6 md:p-8 lg:p-10 rounded-lg my-8 md:my-10 lg:my-14">
                <p className="text-base md:text-lg lg:text-xl font-bold text-[#1A1A2E] mb-4">저희의 생각도 이와 같습니다.</p>
                <p className="text-sm md:text-base lg:text-lg">
                  저희 K-NEXUS MARKETING은 일본 진출에 있어 저희 클라이언트가 한국의 기업이나 대행사가 운영했을 때보다 비약적으로 개선된 사례가 대부분입니다.
                </p>
              </div>
              <p className="text-base md:text-lg lg:text-xl font-bold text-[#3B9AFF]">
                일본인의 심리와 시장 구조를 숙지하고 있는 현지 전문가로서, 귀사가 일본 시장에서 성공을 거둘 수 있도록 최선을 다하겠습니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section
        id="services"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-[#F7FAFF]"
        data-animate="comparison"
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-16 lg:mb-24">
            <h2 className="text-xl md:text-3xl lg:text-5xl font-bold mb-3 md:mb-5 lg:mb-6 text-[#1A1A2E]">
              일본 시장 진출: 웹사이트 전략 비교표
            </h2>
            <p className="text-sm md:text-base lg:text-xl text-[#777] mb-4">
              한일 웹사이트 전략 비교표
            </p>
            <div className="w-16 md:w-20 h-1 bg-[#3B9AFF] mx-auto rounded-full"></div>
          </div>
          <div className="bg-white rounded-xl md:rounded-2xl shadow-xl overflow-hidden border border-[#E0EDFF]">
            {/* スマホ用スクロール矢印 */}
            <div className="flex items-center justify-between px-4 py-2 bg-[#F7FAFF] border-b border-[#E0EDFF] md:hidden">
              <button
                onClick={() => scrollTable('left')}
                className="flex items-center justify-center w-9 h-9 rounded-full bg-white border border-[#E0EDFF] shadow-sm cursor-pointer hover:border-[#3B9AFF] hover:text-[#3B9AFF] transition-all"
                aria-label="왼쪽으로 스크롤"
              >
                <i className="ri-arrow-left-s-line text-xl text-[#3B9AFF]"></i>
              </button>
              <span className="text-xs text-[#999]">← 좌우로 스크롤하세요 →</span>
              <button
                onClick={() => scrollTable('right')}
                className="flex items-center justify-center w-9 h-9 rounded-full bg-white border border-[#E0EDFF] shadow-sm cursor-pointer hover:border-[#3B9AFF] hover:text-[#3B9AFF] transition-all"
                aria-label="오른쪽으로 스크롤"
              >
                <i className="ri-arrow-right-s-line text-xl text-[#3B9AFF]"></i>
              </button>
            </div>
            <div id="comparison-scroll" className="overflow-x-auto">
              <table className="w-full min-w-[600px]">
                <thead>
                  <tr className="bg-gradient-to-r from-[#3B9AFF] to-[#5BB5FF]">
                    <th className="px-4 md:px-6 lg:px-10 py-4 md:py-5 lg:py-7 text-left text-white font-bold text-sm md:text-base lg:text-lg border-r border-white/20">
                      항목
                    </th>
                    <th className="px-4 md:px-6 lg:px-10 py-4 md:py-5 lg:py-7 text-left text-white font-bold text-sm md:text-base lg:text-lg border-r border-white/20">
                      한국식
                    </th>
                    <th className="px-4 md:px-6 lg:px-10 py-4 md:py-5 lg:py-7 text-left text-white font-bold text-sm md:text-base lg:text-lg">
                      일본식
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      label: '1. 정보량 및 구성',
                      kr: '이미지 중심의 미니멀 설계',
                      krDesc: '비주얼 중시의 미니멀 설계.\n큰 이미지와 적은 텍스트량으로 소구.',
                      jp: '상세한 텍스트를 통한 신뢰 구축',
                      jpDesc: '텍스트를 통한 정보의 망라성.\n상세한 설명과 문장량으로 신뢰를 구축.',
                    },
                    {
                      label: '2. 디자인 톤앤매너',
                      kr: '모노톤 기반의 시크한 감성',
                      krDesc: '쿨 & 스타일리시.\n모노톤이나 한색 계열을 기조로 한 세련미.',
                      jp: '따뜻한 색감 기반의 심리적 안정감',
                      jpDesc: '안심감 & 친화성.\n난색 계열을 활용한 심리적 장벽이 낮은 배색.',
                    },
                    {
                      label: '3. 언어 및 라이팅',
                      kr: '직역으로 인한 뉘앙스 부조화',
                      krDesc: '직접적인 번역.\n직역으로 인한 뉘앙스의 불일치.',
                      jp: '정서적 공감을 유도하는 현지화 라이팅',
                      jpDesc: '문맥을 고려한 현지화 라이팅.\n일본인의 정서에 맞춘 자연스러운 라이팅.',
                    },
                    {
                      label: '4. 표현 제한',
                      kr: '주관적·과장된 표현 위주',
                      krDesc: '주관적·과대 표현의 남용.\n「No.1」「최고」등 근거 없는 문구.',
                      jp: '일본 의료광고 가이드라인 철저 준수',
                      jpDesc: '의료광고 가이드라인 준수.\n약기법에 근거한 객관적이고 적정한 표현.',
                    },
                    {
                      label: '5. 페이지 길이',
                      kr: '결론 위주의 짧은 페이지 구성',
                      krDesc: '숏폼.\n결론을 우선한 짧은 페이지 구성.',
                      jp: '납득을 이끌어내는 롱폼 스토리텔링',
                      jpDesc: '롱폼（장척）.\n스토리를 통해 납득감을 형성하는 구성.',
                    },
                  ].map((row, i) => (
                    <tr key={i} className="border-b border-[#E0EDFF] hover:bg-[#F7FAFF] transition-colors">
                      <td className="px-4 md:px-6 lg:px-10 py-5 md:py-6 lg:py-9 font-bold text-sm md:text-base lg:text-lg text-[#1A1A2E] border-r border-[#E0EDFF] bg-[#F7FAFF]">
                        {row.label}
                      </td>
                      <td className="px-4 md:px-6 lg:px-10 py-5 md:py-6 lg:py-9 border-r border-[#E0EDFF]">
                        <div className="mb-1 md:mb-2 font-bold text-sm md:text-base lg:text-lg text-[#FF6B6B]">
                          {row.kr}
                        </div>
                        <div className="text-xs md:text-sm lg:text-base text-[#555] leading-relaxed whitespace-pre-line">
                          {row.krDesc}
                        </div>
                      </td>
                      <td className="px-4 md:px-6 lg:px-10 py-5 md:py-6 lg:py-9">
                        <div className="mb-1 md:mb-2 font-bold text-sm md:text-base lg:text-lg text-[#3B9AFF]">
                          {row.jp}
                        </div>
                        <div className="text-xs md:text-sm lg:text-base text-[#555] leading-relaxed whitespace-pre-line">
                          {row.jpDesc}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <p className="text-center text-base md:text-xl lg:text-2xl text-[#3B9AFF] mt-8 md:mt-12 lg:mt-16 font-medium">
            전략의 차이가 성과의 차이를 만듭니다.
          </p>
        </div>
      </section>

      {/* Legal Section */}
      <section
        id="legal"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-white"
        data-animate="legal"
      >
        <div className="max-w-5xl mx-auto">
          <div className={`transition-all duration-700 ${isVisible.legal ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="text-center mb-10 md:mb-14 lg:mb-20">
              <p className="text-[#FF6B6B] text-xs lg:text-sm font-bold tracking-[3px] mb-3 md:mb-4 uppercase">
                LEGAL COMPLIANCE
              </p>
              <h2 className="text-xl md:text-3xl lg:text-5xl font-bold text-[#1A1A2E] leading-tight mb-6 md:mb-8">
                일본 시장 내 법적 리스크를<br />실무 레벨에서 회피합니다.
              </h2>
            </div>
            <div className="space-y-6 md:space-y-7 lg:space-y-8 text-sm md:text-base lg:text-lg leading-relaxed text-[#444]">
              <p>
                한국에서 일반적으로 사용되는{' '}
                <strong className="text-[#FF6B6B]">"No.1", "최고"</strong>와 같은 표현은 일본 의료광고 가이드라인에서
                엄격히 금지됩니다. 특히 <strong className="text-[#1A1A2E]">의료법 제6조 5 제1항</strong>에 따라 비교
                우위 광고나 과대 광고는 처벌 대상이며, 위반 시 광고 계정 정지는 물론 행정 지도로 인해 일본 내 활동이 어려워질
                리스크가 있습니다. <strong className="text-[#FF6B6B]">최악의 경우 영업정지에 이를 수도 있습니다.</strong>
              </p>
              <p>비포&amp;애프터 사진 한 장에도 비용과 부작용을 명시해야 하는 상세한 규정이 존재합니다.</p>
              <p>
                또한 <strong className="text-[#1A1A2E]">'약사법(의약품, 의료기기 등의 품질, 유효성 및 안전 확보 등에 관한 법률)' 제66조</strong>에서도
                과대 광고를 금지하고 있으며, 화장품이나 미용 기기의 효능 표현 범위는 엄격히 규정되어 있습니다. 미승인 의료기기나
                시술에 관한 광고 역시 제68조에 의해 엄격히 제한되므로, 이를 무시한 운영은 귀사의 일본 내 브랜드 가치를 실추시키는 치명적인
                리스크가 됩니다.
              </p>
              <div className="bg-[#FFF5F5] border-l-4 border-[#FF6B6B] p-6 md:p-8 lg:p-10 rounded-lg my-8 md:my-10 lg:my-14">
                <p className="text-sm md:text-base lg:text-lg">
                  현재 이러한 법규를 지키지 못하는 일부 한국 기업들이 보이지만, 한일 비즈니스가 더욱 확대될 미래에는 결국 현지의 법규를 철저히 준수하는 기업만이 일본 시장에서 살아남을 수 있습니다.
                </p>
              </div>
              <div className="bg-gradient-to-br from-[#3B9AFF] to-[#5BB5FF] text-white p-8 md:p-10 lg:p-14 rounded-2xl shadow-xl">
                <h3 className="text-lg md:text-xl lg:text-2xl font-bold mb-4 md:mb-5 lg:mb-6">K-NEXUS의 리걸 시스템</h3>
                <p className="text-sm md:text-base lg:text-lg leading-relaxed">
                  K-NEXUS는 일본 현지 고문 변호사와 협력하여 제작 전 과정에서 <strong>총 2회의 리걸 체크</strong>를 실시합니다.
                  이는 단순한 제작 공정이 아니라 귀사의 브랜드를 일본에서 안전하게 보호하기 위한 체계입니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section
        id="process"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-[#F7FAFF]"
        data-animate="process"
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-16 lg:mb-24">
            <p className="text-[#3B9AFF] text-xs lg:text-sm font-bold tracking-[3px] mb-3 md:mb-4 uppercase">
              12-STEP STRATEGY
            </p>
            <h2 className="text-xl md:text-3xl lg:text-5xl font-bold text-[#1A1A2E] mb-4 md:mb-5 lg:mb-6">
              일본 웹사이트 제작 12단계
            </h2>
            <p className="text-[#777] text-xs md:text-sm lg:text-base">
              ※ 모든 공정은 최단 1개월에서 최장 2.5개월 이내에 완료됩니다.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 lg:gap-8">
            {processSteps.map((step, index) => (
              <div
                key={step.number}
                className={`bg-white border border-[#E0EDFF] rounded-xl p-5 md:p-6 lg:p-8 hover:border-[#3B9AFF] hover:shadow-lg hover:shadow-[#3B9AFF]/10 hover:-translate-y-1 transition-all duration-300 ${
                  isVisible.process ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#3B9AFF] to-[#5BB5FF] flex items-center justify-center flex-shrink-0 shadow-md shadow-[#3B9AFF]/30">
                    <span className="text-white text-sm font-bold">{step.number}</span>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl text-[#3B9AFF]`}></i>
                  </div>
                  <h3 className="text-sm font-bold text-[#1A1A2E] leading-snug">{step.title}</h3>
                </div>
                <p className="text-xs text-[#777] leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section
        id="faq"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-[#F7FAFF]"
        data-animate="faq"
      >
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-16 lg:mb-24">
            <p className="text-[#3B9AFF] text-xs lg:text-sm font-bold tracking-[3px] mb-3 md:mb-4 uppercase">FAQ</p>
            <h2 className="text-xl md:text-3xl lg:text-5xl font-bold text-[#1A1A2E]">자주 묻는 질문</h2>
          </div>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`bg-white border rounded-xl overflow-hidden transition-all duration-300 ${
                  openFaq === index ? 'border-[#3B9AFF] shadow-lg shadow-[#3B9AFF]/10' : 'border-[#E0EDFF] hover:border-[#3B9AFF]/50'
                } ${isVisible.faq ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 40}ms` }}
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-6 md:px-8 lg:px-10 py-4 md:py-5 lg:py-6 flex items-center justify-between gap-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base lg:text-lg font-bold text-[#1A1A2E] flex items-start gap-2 md:gap-3">
                    <span className="text-[#3B9AFF] flex-shrink-0 font-extrabold">Q.</span>
                    <span>{faq.question}</span>
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-xl lg:text-2xl text-[#3B9AFF]"></i>
                  </div>
                </button>
                <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="px-6 md:px-8 lg:px-10 pb-5 md:pb-6 lg:pb-8">
                    <div className="w-full h-px bg-[#E0EDFF] mb-4"></div>
                    <div className="flex items-start gap-2 md:gap-3">
                      <span className="text-[#3B9AFF] font-extrabold text-sm md:text-base flex-shrink-0">A.</span>
                      <p className="text-xs md:text-sm lg:text-base text-[#555] leading-relaxed whitespace-pre-line">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CEO Message Section */}
      <section
        id="ceo-message"
        className="py-16 md:py-24 lg:py-36 px-4 md:px-6 lg:px-10 bg-white"
        data-animate="ceo-message"
      >
        <div className="max-w-5xl mx-auto">
          <div className={`transition-all duration-700 ${isVisible['ceo-message'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="text-center mb-10 md:mb-14 lg:mb-20">
              <p className="text-[#3B9AFF] text-xs lg:text-sm font-bold tracking-[3px] mb-3 md:mb-4 uppercase">CEO MESSAGE</p>
              <h2 className="text-xl md:text-3xl lg:text-5xl font-bold text-[#1A1A2E] leading-tight mb-4 md:mb-6">
                한국의 훌륭한 가치를<br />한 치의 오차 없이 일본에 연결합니다
              </h2>
            </div>
            <div className="bg-gradient-to-br from-[#F7FAFF] to-white border-2 border-[#E0EDFF] rounded-2xl p-8 md:p-10 lg:p-16 shadow-xl">
              <div className="flex items-center gap-4 md:gap-6 lg:gap-8 mb-8 md:mb-10 lg:mb-12">
                <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full overflow-hidden flex-shrink-0 shadow-lg border-2 border-[#E0EDFF]">
                  <img
                    src="https://static.readdy.ai/image/b1989ece91adf9f4c331600c20412c5d/8cd49cbcc4a6f4757e918e4d4108862f.jpeg"
                    alt="이나바 카이세이 대표이사"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-xs md:text-sm lg:text-base text-[#777] mb-1">대표 이사</p>
                  <p className="text-lg md:text-xl lg:text-3xl font-bold text-[#1A1A2E]">이나바 카이세이</p>
                </div>
              </div>
              <div className="space-y-5 md:space-y-6 lg:space-y-7 text-sm md:text-base lg:text-lg leading-relaxed text-[#444]">
                <p>
                  대표 이나바 카이세이입니다. 저는 일본 시장만을 대상으로 사업을 시작했을 때보다, 한국 기업 및
                  분들과 협업을 시작하며 비로소 <strong className="text-[#1A1A2E]">'일이 즐겁다'</strong>는 것을 느끼게
                  되었습니다.
                </p>
                <p>
                  한국 사람들이 가진 정, 그리고 탁월한 제품력과 기술력을{' '}
                  <strong className="text-[#3B9AFF]">'일본인에게 가장 적합한 형태로 전달하는 것'</strong>, 이것이
                  한일 마케팅의 본질이라 믿습니다.
                </p>
                <div className="bg-white border-l-4 border-[#3B9AFF] p-6 md:p-8 lg:p-10 rounded-lg my-6 md:my-8 lg:my-10">
                  <p className="text-base md:text-lg lg:text-xl font-bold text-[#1A1A2E]">
                    저희에게 믿고 맡겨주신다면 지불하신 비용 그 이상의 가치를 증명하여,
                    <br />
                    귀사를 일본 시장의 승자로 만들겠습니다.
                  </p>
                </div>
                <p className="text-base md:text-lg lg:text-2xl font-bold text-[#3B9AFF] text-center pt-4 md:pt-6">
                  함께할 날을 진심으로 기대하고 있겠습니다!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#F0F5FF] border-t border-[#E0EDFF] py-8 md:py-10 lg:py-14 px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
            <div className="flex items-center gap-3 md:gap-4">
              <img
                src="https://static.readdy.ai/image/b1989ece91adf9f4c331600c20412c5d/d4a602daafc972804a8f79cf255edce9.png"
                alt="K-NEXUS"
                className="h-8 md:h-10 lg:h-12 w-auto object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-[#1A1A2E] font-bold text-sm md:text-base lg:text-lg tracking-wide">
                  K-NEXUS
                </span>
                <span className="text-[#3B9AFF] font-semibold text-[10px] md:text-xs tracking-wider">
                  MARKETING
                </span>
              </div>
            </div>
            <div className="text-[#999] text-xs lg:text-sm flex flex-col md:flex-row gap-2 md:gap-6 items-center">
              <p>&copy; 2026 K-NEXUS. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>

      {/* 固定CTAボタン */}
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40">
        <a
          href="/contact"
          style={{
            minWidth: '300px',
            animation: 'ctaPulse 5.6s ease-in-out infinite',
          }}
          className="flex items-center justify-center gap-2 md:gap-3 bg-[#3B9AFF] text-white px-7 md:px-10 py-3.5 md:py-4 rounded-full text-sm md:text-base font-bold shadow-2xl shadow-[#3B9AFF]/40 hover:bg-[#2B8AEF] cursor-pointer inline-flex"
        >
          <i className="ri-message-3-line text-base md:text-lg flex-shrink-0"></i>
          <span
            style={{
              position: 'relative',
              display: 'inline-block',
              minWidth: '220px',
              height: '1.5em',
              textAlign: 'center',
            }}
          >
            {ctaTexts.map((text, i) => (
              <span
                key={i}
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 0,
                  whiteSpace: 'nowrap',
                  opacity: ctaIndex === i ? 1 : 0,
                  transform: ctaIndex === i ? 'translateY(0px) scale(1)' : 'translateY(4px) scale(0.95)',
                  transition: 'opacity 0.5s cubic-bezier(0.4,0,0.2,1), transform 0.5s cubic-bezier(0.4,0,0.2,1)',
                  pointerEvents: 'none',
                }}
              >
                {text}
              </span>
            ))}
          </span>
          <i className="ri-arrow-right-line text-base md:text-lg flex-shrink-0"></i>
        </a>
      </div>
    </div>
  );
}
